/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// MUI v4 FormHelperText, NS/Tractie helptext + error-message pendant overrides.
// Tractie sources: helptext (default state) en error-message (error state).
// Strategie per spec aanbeveling: state-toggle via &$error (matched MUI DOM).
// Mode-split: Dark spread Light.

export const MuiFormHelperTextLightOverrides = {
  root: {
    color: 'var(--ns-color-fg-subtle)',
    fontSize: 'var(--ns-font-size-s)',
    fontWeight: 400,
    lineHeight: 'var(--ns-font-leading-l)',
    marginTop: 'var(--ns-space-1)',
    marginLeft: 0,
    marginRight: 0,
    '&$error': {
      color: 'var(--ns-color-fg-error)',
    },
    '&$disabled': {
      opacity: 0.5,
    },
  },

  contained: {
    marginLeft: 0,
    marginRight: 0,
  },

  marginDense: {
    marginTop: 'var(--ns-space-1)',
  },

  error: {},
  disabled: {},
  focused: {},
  filled: {},
  required: {},
} as const;

export const MuiFormHelperTextDarkOverrides = {
  ...MuiFormHelperTextLightOverrides,
} as const;
